export { default } from "./ProcessSection";
